import React, { useState, useEffect } from "react";
import { Col } from "reactstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { withRouter } from "../../utils/utility";
import { Lock } from "react-feather";

import { logoutUser } from "../../actions/authActions";
import {
  getUserDashboardLink,
  getUserRoles,
  getUserBusinesses,
  encryptUserRole,
  isStaffPortalDeactivated,
  isStaffPortalRoleLocked,
} from "../../utils/authHelper";
import isEmpty from "../../validation/is-empty";
import { notification } from "../../utils/utility";

const STAFF_DEACTIVATED_MESSAGE =
  "Staff portal access is locked. Please contact your administrator.";

const UserType = (props) => {
  const navigate = useNavigate();

  const [userType, setUserType] = useState(null);
  const [userBusiness, setUserBusiness] = useState(null);

  const config = JSON.parse(localStorage.getItem("config") || "{}");
  const user = config.user || {};
  const staffPortalLocked = isStaffPortalDeactivated();

  useEffect(() => {
    if (props.auth.isAuthenticated && localStorage.userType) {
      if (
        localStorage.userType === encryptUserRole("staff") &&
        isStaffPortalDeactivated()
      ) {
        localStorage.removeItem("userType");
        localStorage.removeItem("businessId");
      } else {
        navigate(getUserDashboardLink(localStorage.userType));
      }
    }

    if (!props.auth.isAuthenticated) {
      navigate("/admin/login");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.auth.isAuthenticated]);

  /**
   * Get User Role Icon
   * @param String role
   * @returns String
   */
  const getRoleIcon = (role) => {
    const isLocked = isStaffPortalRoleLocked(role);

    switch (role) {
      case "customer":
        return (
          <a href="#" className="rd_splashcard rd_splashcardadmin" onClick={(e) => e.preventDefault()}></a>
        );
      case "admin":
        return (
          <a href="#" className="rd_splashcard rd_splashcardadmin" onClick={(e) => e.preventDefault()}></a>
        );
      case "staff":
        return (
          <a
            href="#"
            className={`rd_splashcard rd_splashcardstaff${isLocked ? " rd_splashcard--locked" : ""}`}
            onClick={(e) => e.preventDefault()}
          >
            {isLocked ? (
              <span className="rd_splashcard-lock">
                <Lock size={28} />
                <span>Locked</span>
              </span>
            ) : null}
          </a>
        );
      default:
        return (
          <a href="#" className="rd_splashcard rd_splashcardsuperadmin" onClick={(e) => e.preventDefault()}></a>
        );
    }
  };

  /**
   * on close button handler
   */
  const onCloseHandler = () => {
    props.logoutUser();
    navigate("/admin/login");
  };

  /**
   * on continue button handler
   */
  const onContinueHandler = () => {
    if (!userType) {
      return notification.error("Please select user type");
    }

    if (isStaffPortalRoleLocked(userType)) {
      return notification.warning(STAFF_DEACTIVATED_MESSAGE);
    }

    if (userType === "admin" && !userBusiness) {
      return notification.error("Please select type of business");
    }

    if (userType !== "admin") {
      localStorage.setItem("userType", encryptUserRole(userType));
      if (userType === "staff" && localStorage.config) {
        const config = JSON.parse(localStorage.config);
        localStorage.setItem("businessId", config.staff_business_id);
      }
      navigate(getUserDashboardLink(localStorage.userType));
    } else {
      if (userBusiness !== null) {
        localStorage.setItem("userType", encryptUserRole(userType));
        localStorage.setItem("businessId", userBusiness);
        navigate(getUserDashboardLink(localStorage.userType));
      }
    }
  };

  const roles = getUserRoles();
  let businesses = getUserBusinesses();

  let userRoles = null;
  if (!isEmpty(roles) && roles.length > 1) {
    userRoles = roles.map((role, index) => {
      const isLocked = isStaffPortalRoleLocked(role);

      return (
        <div
          className={`rd_carditem user_card ${
            role == userType ? "rd_splashitemselected" : ""
          }${isLocked ? " rd_carditem--locked" : ""}`}
          key={index}
          onClick={() => {
            if (isLocked) {
              notification.warning(STAFF_DEACTIVATED_MESSAGE);
              return;
            }
            setUserType(role);
          }}
        >
          {getRoleIcon(role)}
          {isLocked ? (
            <p className="rd_splashcard-message">{STAFF_DEACTIVATED_MESSAGE}</p>
          ) : null}
        </div>
      );
    });
  } else if (!isEmpty(roles) && roles.length === 1 && staffPortalLocked && roles[0] === "staff") {
    userRoles = (
      <div className="rd_carditem user_card rd_carditem--locked rd_carditem--locked-only">
        {getRoleIcon("staff")}
        <p className="rd_splashcard-message">{STAFF_DEACTIVATED_MESSAGE}</p>
      </div>
    );
  }

  let userBusinesses = null;
  if (!isEmpty(businesses) && Object.keys(businesses).length > 1) {
    businesses = Object.keys(businesses).map((key) => [key, businesses[key]]);
    userBusinesses = businesses.map((business, index) => {
      const [businessName, businessId] = business;
      return (
        <div
          className={`rd_carditem rd_carditemsub ${
            businessId == userBusiness ? "rd_splashitemselected" : ""
          }`}
          key={businessId}
        >
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setUserBusiness(businessId);
            }}
            className={
              businessId == 1
                ? "rd_splashcard rd_splashcardhairsalon"
                : "rd_splashcard rd_splashcardacademy"
            }
          ></a>
        </div>
      );
    });
  } else if (
    !isEmpty(businesses) &&
    Object.keys(businesses).length === 1 &&
    userBusiness === null
  ) {
    setUserBusiness(businesses[Object.keys(businesses)[0]]);
  }

  const showContinue =
    !(roles?.length === 1 && staffPortalLocked && roles[0] === "staff");

  return (
    <div className="container">
      <div className="eventdetailsaddbox rd_noshadow">
        <div className="rd_pasevencontth rd_pasevencontth2">
          <h4>Select User Type</h4>
          {staffPortalLocked && roles?.includes("staff") ? (
            <p className="rd_splash-deactivated-banner">{STAFF_DEACTIVATED_MESSAGE}</p>
          ) : null}
          {userRoles && (
            <div className="rd_eventcardscontainer justify-content-center">
              {userRoles}
            </div>
          )}

          {userBusinesses && userType === "admin" && (
            <>
              <h4>Select Business Type</h4>
              <div className="rd_eventcardscontainer justify-content-center">
                {userBusinesses}
              </div>
            </>
          )}

          <Col md="12" className="text-right mt-2 mb-2">
            <button
              className="rd_mainbuttonstylelight"
              type="button"
              onClick={onCloseHandler}
            >
              Cancel
            </button>
            {showContinue ? (
              <button
                className="rd_mainbuttonstyleorange"
                type="button"
                onClick={onContinueHandler}
              >
                Continue
              </button>
            ) : null}
          </Col>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(withRouter(UserType));
